import { render, staticRenderFns } from "./AccountCreatedSuccessfully.vue?vue&type=template&id=6eb5fec6&scoped=true&"
import script from "./AccountCreatedSuccessfully.vue?vue&type=script&lang=js&"
export * from "./AccountCreatedSuccessfully.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5fec6",
  null
  
)

export default component.exports